import * as ErrorModalActions from "./action";
import { reducer, State as ErrorModalState } from "./reducer";

export { ErrorModalActions };
export type { ErrorModalState };
export default reducer;
